import Vue from 'vue';
import VueAlert from "vue-simple-alert";
import Notifications from 'vue-notification';
import Moment from '@/plugins/moment';
import Vuetify from '@/plugins/vuetify';
import Firebase from '@/plugins/firebase';
import CountryFlag from 'vue-country-flag';

import Router from '@/router';
import Store from '@/store';
import App from '@/App.vue';
import JsonViewer from 'vue-json-viewer';
import AsciiOnly from "@/common/AsciiOnly";

Store.dispatch('init', null, {root: true});

Vue.config.productionTip = false;
Vue.use(VueAlert, {width: "300px"});
Vue.use(Notifications);
Vue.use(JsonViewer);
Vue.use(AsciiOnly);
Vue.component('country-flag', CountryFlag);

new Vue({
  moment: Moment,
  vuetify: Vuetify,
  firebase: Firebase,
  store: Store,
  router: Router,
  countryFlag: CountryFlag,
  render: h => h(App)
}).$mount('#app')
